module.exports = __webpack_public_path__ + "img/chevron-right.7f6d69e8.svg";